export default __webpack_public_path__ + "static/media/To-Do-List.5df74b4d.png";